
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import get from 'lodash/get'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import authAction from './../../actions/auth.actions'
import LoginCard from './../../components/LoginCard'
import Hero from './../../components/Hero'
import { showNotification } from '../../actions/notification.action'
import { hideLoader } from '../../actions/loader.action'
import placeholderImage from './../../images/placeholder.png'

import './Login.scss'
import { mapAuthData, getCookieValue, clearCookie, initializeRefreshToken, setLoggedInUserData, saveAuthToStorage, getAuthDataFromStorage } from '../../helpers/util'
import routes from '../../constants/routes'
import isEmpty from 'lodash/isEmpty'
import { APP_AUTH_NAME } from '../../constants'

const authCookieName = 'auth' 
const userCookieName = 'user' 

const Login = ({actions, history}) => { 
  const [error, setError] = useState('')
  const basicToken = get(window, '__APP_ENV__.BASIC_TOKEN')
  const clientId = get(window, '__APP_ENV__.CLIENT_ID')
  const baseURL = `${get(window, '__APP_ENV__.BASE_URL')}`
  const context = get(window, '__APP_ENV__.CONTEXT')
  const samlLogin = JSON.parse(get(window, '__APP_ENV__.samlLogin', 'false'))

  useEffect(() => {

    if (samlLogin) {
      redirectSamLogin()
    }
  }, [])
  const onSubmitHandler = state => {
    setError('')
    axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `basic ${basicToken}`
      },
      data: { ...state, ...{ appId: clientId } },
      url: `${baseURL}/login`
    }).then(response => {
      const { data } = response
      initializeRefreshToken(data)
      setLoggedInUserData(data)
      saveAuthToStorage(data, state.rememberMe)
      actions.auth(data)
    })
      .catch(() => {
        actions.hideLoader()
        actions.showNotification({
          class: 'is-danger',
          message: 'Username or password is wrong'
        })
        // setError('Username or password is wrong')
      })
  }

  const setUserData = ( authData ) => {
    actions.auth(authData)
    return setTimeout(() => {
      clearCookie(authCookieName)
      localStorage.removeItem('auth')
      sessionStorage.removeItem('auth')
      localStorage.removeItem('roles')
      sessionStorage.removeItem('roles')
      localStorage.removeItem(APP_AUTH_NAME)
      history.push(`/${context}/${routes.dashboard}`)
    }, 100)
  }

  const redirectSamLogin = () => {
    const authCookie = getCookieValue(authCookieName)
    const userCokkie = getCookieValue(userCookieName)
    if ((!authCookie || authCookie == '') && isEmpty(getAuthDataFromStorage())) {
      const encoded = encodeURIComponent(`${window.location.origin}/${context}/`)
      window.location = `${window.location.origin}/${context}/slogin?redirectUri=${encoded}`
      // window.location = `http://localhost:5000/${context}/slogin?redirectUri=${encoded}`
    } else {
      const getAuthData = mapAuthData({ auth: decodeURIComponent(authCookie), user: decodeURIComponent(userCokkie) })
      saveAuthToStorage(getAuthData, true)
      initializeRefreshToken(getAuthData)
      setLoggedInUserData(getAuthData)
      setError('')
      clearCookie(authCookieName)
      clearCookie(userCookieName)

      axios({
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${get(getAuthData, 'tokenDetail.accessToken', '')}`
        },
        url: `${window.location.origin}/${context}/roles`
      }).then(response => {
        const { data } = response
        getAuthData.userProfileDetail['roleDetail'] = data
        setUserData(getAuthData)
      })
        .catch(() => {
          actions.hideLoader()
          setUserData(getAuthData)
        })
    }
  }

  if (!samlLogin) {
    return (
      <div className="LoginContainer__div">
        <Hero className="is-height-16" backgroundImage={placeholderImage} />
        <LoginCard
          title="EMBARKATION ADMIN"
          onSubmit={onSubmitHandler}
          error={error}
        />
      </div>
    )
  } else {
    return (<div></div>)
  }
}

Login.propTypes = {
  actions: PropTypes.shape({
    auth: PropTypes.func,
    showNotification: PropTypes.func,
    hideLoader: PropTypes.func
  }).isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators( { auth: authAction, showNotification,hideLoader },
      dispatch
    )
  }
}

export default connect( 
  null,
  mapDispatchToProps
)(Login)